"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDividerClassNames = void 0;
var Utilities_1 = require("../../Utilities");
var Styling_1 = require("../../Styling");
/**
 * @deprecated use getStyles exported from VerticalDivider.styles.ts
 */
exports.getDividerClassNames = (0, Utilities_1.memoizeFunction)(
// eslint-disable-next-line @typescript-eslint/no-deprecated
function (theme) {
    return (0, Styling_1.mergeStyleSets)({
        wrapper: {
            display: 'inline-flex',
            height: '100%',
            alignItems: 'center',
        },
        divider: {
            width: 1,
            height: '100%',
            backgroundColor: theme.palette.neutralTertiaryAlt,
        },
    });
});
//# sourceMappingURL=VerticalDivider.classNames.js.map